import { useState } from "react";
import { Autocomplete, InputAdornment } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import cn from "classnames";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { changeServerWebConnector, deleteServerWebConnector } from "@/store/ses/sesConnectorSlice";
import { selectDataServers } from "@/store/serverSlice";
import { useTranslate } from "@/hooks";
import { colorPrimary, colorRed } from "@/constants/colors";
import CustomTextField from "@/components/MUI/CustomTextField/CustomTextField";
import { IServerProps } from "./Server.props";
import styles from "./Server.module.scss";

const Server = ({ channel, server, idx, array, changeFlgHandler, isDisabled }: IServerProps): JSX.Element => {
	const [inputServer, setInputServer] = useState<string>(server); // сервер

	const dispatch = useAppDispatch();
	const dataServers = useAppSelector(selectDataServers); // store - данные о серверах

	const translate = useTranslate(); // hook для перевода текста

	// обработчик изменения сервера
	const serverChangeHandler = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>): void => {
		if (array.length - 1 === idx) dispatch(changeServerWebConnector({ channel, serverIdx: idx, server: inputServer }));
		setInputServer(e.target.value);
	};

	// обработчик сохранения сервера
	const serverSaveHandler = (value?: string): void => {
		if (server === (value || inputServer)) return;
		dispatch(changeServerWebConnector({ channel, serverIdx: idx, server: value || inputServer }));
		changeFlgHandler("params");
	};

	// обработчик удаления сервера
	const serverDeleteHandler = (): void => {
		dispatch(deleteServerWebConnector({ channel, serverIdx: idx }));
		changeFlgHandler("params");
	};

	return (
		<div
			className={cn(styles.server, {
				[styles.serverOpacity]: array.length - 1 === idx,
				[styles.serverHidden]: array.length - 1 === idx && isDisabled,
			})}
		>
			<Autocomplete
				fullWidth
				freeSolo
				options={Object.values(dataServers?.websockets || {})}
				value={inputServer}
				onChange={(_, value) => {
					setInputServer(value ? value : "");
					value && serverSaveHandler(value);
				}}
				disabled={isDisabled}
				renderInput={(params) => (
					<CustomTextField
						{...params}
						placeholder={translate("input_addServer")}
						value={inputServer}
						onChange={serverChangeHandler}
						onBlur={() => serverSaveHandler()}
						error={!inputServer && array.length - 1 !== idx}
						InputProps={{
							...params.InputProps, // важно прокинуть параметры
							endAdornment: (
								<InputAdornment position="end">
									{!isDisabled && array.length > 1 && array.length - 1 !== idx && (
										<div className={styles.deletePhraseButton}>
											<FontAwesomeIcon
												icon={faTrashCan}
												color={colorRed}
												size="sm"
												onClick={serverDeleteHandler}
												title={translate("button_delete")}
												style={{ cursor: "pointer" }}
											/>
										</div>
									)}
									{params.InputProps.endAdornment} {/* важно дописать параметры */}
								</InputAdornment>
							),
						}}
					/>
				)}
				renderOption={(props, option) => {
					return (
						<span {...props} style={{ fontSize: 13, color: colorPrimary }} key={option}>
							{option}
						</span>
					);
				}}
			/>
		</div>
	);
};

export default Server;
